module.exports = __webpack_public_path__ + "img/empty-plan.bcca32e0.webp";